<div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px;">
  <!-- Left: Certiplate Text -->
  <div style="flex: 0 0 auto; font-size: 18px; font-weight: 600; color: #1ABC9C;">
    Certiplate
  </div>

  <!-- Center: Title -->
  <h3 id="hdrImageTitle" class="modal-title mb-0" style="color: #34495e; flex: 1; text-align: center; font-size: 16px; font-weight: 600;">
    Admit Card
  </h3>

  <!-- Right: Close Button -->
  <button
    type="button"
    style="color: black; flex: 0 0 auto; background: none; border: none; font-size: 24px; cursor: pointer;"
    title="Close"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    mat-dialog-close
    >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner
      class="mat-spinner-color"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
}

@if (!isLoading) {
  <div>
    <div id="printable-wrapper">
      <div id="pdfTable" #pdfTable>
        <!--  =====  HEADER  =====  -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4pt; padding-bottom: 2pt;">
          <div style="font-size: 14pt; font-weight: bold; color: #4EAC6E;">
            Certiplate
          </div>
          <h1 style="margin: 0; text-align: center; flex: 1; color: #34495e; font-size: 16pt;">Admit Card</h1>
          <div style="width: 60pt;"></div>
        </div>
        <div style="display: flex; gap: 24pt; margin-top: 4pt;">
          <!-- LEFT SECTION: Candidate Information -->
          <div style="flex: 1;">
            <table style="border-collapse: collapse; width: 100%;" cellspacing="0">
              <!-- Candidate Name -->
              <tr>
                <td style="padding: 6pt; font-weight: 600; width: 35%;">Candidate Name</td>
                <td style="padding: 6pt; border-bottom: 1px solid #ddd;">{{ candidateDetails?.full_name }}</td>
              </tr>
              <!-- Dynamic Custom Attributes (excluding Roll Number and Registration ID) -->
              @for (attr of getFilteredCustomAttributes(); track attr) {
                <tr>
                  <td style="padding: 6pt; font-weight: 600;">{{ attr.label }}</td>
                  <td style="padding: 6pt; border-bottom: 1px solid #ddd;">{{ attr.value }}</td>
                </tr>
              }
              <!-- Email - Only if it has a value -->
              @if (candidateDetails?.email) {
                <tr>
                  <td style="padding: 6pt; font-weight: 600;">Email</td>
                  <td style="padding: 6pt; border-bottom: 1px solid #ddd;">{{ candidateDetails?.email }}</td>
                </tr>
              }
            </table>
          </div>
          <!-- RIGHT SECTION: Photo and Signature -->
          <div style="flex: 0 0 110pt;">  <!-- width increased from 80pt -->
            <!-- Photo Box -->
            <div style="
              border: 2px dotted #ececec;
              margin-bottom: 12pt;
              width: 180px;
              height: 140pt;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f9f9f9;
            ">
              <div style="text-align: center; color: #999; font-size: 10pt;">
                PHOTO
              </div>
            </div>
            <!-- Signature Box -->
            <div style="
              border: 2px dotted #ececec;
              width: 180px;
              height: 50pt;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f9f9f9;
            ">
              <div style="text-align: center; color: #999; font-size: 10pt;">
                SIGN
              </div>
            </div>
          </div>
        </div>
        <!--  =====  EXAM SCHEDULE  =====  -->
        <h2 style="margin-top: 12pt; text-align: center">Exam Schedule &amp; Login Credentials</h2>
        <table style="border-collapse: collapse; width: 100%;" border="1" cellspacing="0">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="padding: 6pt; font-weight: 600; width: 20%; text-align: left; border-right: 2px solid #ccc;">Assessment</th>
              <th style="padding: 6pt; font-weight: 600; text-align: left; border-right: 2px solid #ccc;">Assessment Details</th>
            </tr>
          </thead>
          <tbody>
            @for (exam of exams; track exam) {
              <tr>
                <!-- LEFT: Assessment Name -->
                <td style="padding: 8pt; vertical-align: middle; border-right: 2px solid #ccc; width: 20%; text-align: center;">
                  {{ exam.title }}
                </td>
                <!-- RIGHT: Assessment Details -->
                <td style="padding: 2pt; vertical-align: top;">
                  <table style="border-collapse: collapse; width: 100%;" cellspacing="0">
                    <!-- Exam StartDate Row -->
                    <tr>
                      <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 30%;">Exam StartDate</td>
                      <td style="padding: 4pt; border-bottom: 1px solid #ddd;">{{ formatExamDate(exam.start_datetime) }}</td>
                    </tr>
                    <!-- Exam EndDate Row -->
                    <tr>
                      <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 30%;">Exam EndDate</td>
                      <td style="padding: 4pt; border-bottom: 1px solid #ddd;">{{ formatExamDate(exam.end_datetime) }}</td>
                    </tr>
                    <!-- Conditional: Login ID Row (only if loginMode is login_id) -->
                    @if (isLoginIdMode(exam)) {
                      <tr>
                        <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 30%;">Login ID</td>
                        <td style="padding: 4pt; border-bottom: 1px solid #ddd;">{{ getLoginId() }}</td>
                      </tr>
                    }
                    <!-- Conditional: Assessment Link Row (only if loginMode is NOT login_id) -->
                    @if (!isLoginIdMode(exam)) {
                      <tr>
                        <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 30%;">Assessment Link</td>
                        <td style="padding: 4pt; border-bottom: 1px solid #ddd; font-size: 9pt;">
                          @if (exam.link && exam.link.length <= 30) {
                            <span>{{ exam.link }}</span>
                          }
                          @if (exam.link && exam.link.length > 30) {
                            <span>
                              <div style="word-break: break-all; font-size: 8pt;">{{ exam.link }}</div>
                            </span>
                          }
                        </td>
                      </tr>
                    }
                    <!-- Code Row (always show) -->
                    <tr>
                      <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 30%;">Code</td>
                      <td style="padding: 4pt; border-bottom: 1px solid #ddd;">{{ exam.code }}</td>
                    </tr>
                    <!-- Custom Attributes Rows (if available) -->
                    @for (attr of getExamCustomAttributes(exam); track attr) {
                      <tr>
                        <td style="padding: 4pt; font-weight: 600; border-right: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{ attr.label }}</td>
                        <td style="padding: 4pt; border-bottom: 1px solid #ddd;">{{ attr.value }}</td>
                      </tr>
                    }
                  </table>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <!--  =====  ASSESSMENT INSTRUCTIONS  =====
        <div *ngFor="let exam of exams">
          <h3 style="margin-top: 12pt;">{{ exam.title }} - Instructions</h3>
          <div style="padding: 8pt; text-align: justify;" [innerHTML]="exam.instructions"></div>
        </div>-->
        <div class="page-break" style="page-break-before: always; break-before: page; margin-top: 24pt; padding-top: 10pt;">
          <h3 style="margin-top: 0; font-size: 14pt; color: #34495e;">Note:</h3>
          <ul style="padding-left: 18pt; text-align: justify; margin-top: 8pt;">
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              Please read the instructions on the next page carefully to understand the procedure for writing this online examination.
            </li>
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              All information on this admit card is confidential and must not be shared.
            </li>
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              Admit card should only be considered valid with a clearly visible photograph and signature.
            </li>
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              Admit card should support candidate verification during entry and attendance validation.
            </li>
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              Candidates are required to carry a valid government-issued photo ID proof
              (e.g., Aadhaar Card, PAN Card, Passport, Driving License, or Voter ID).
            </li>
            <li style="margin-bottom: 8pt; font-size: 10pt; line-height: 1.4;">
              Candidates may also be required to carry a recent passport-size photograph
              as instructed by the examination authority.
            </li>
          </ul>
        </div>
        <!--  =====  GENERAL INSTRUCTIONS  =====  -->
        <h3 style="margin-top: 12pt;">General Instructions</h3>
        <ol style="padding-left: 16pt; text-align: justify;">
          @for (instruction of instructions; track instruction) {
            <li>{{ instruction }}</li>
          }
        </ol>
        <p style="padding-top: 6pt; text-align: center;">This is a computer‑generated admit card.</p>
      </div>
    </div>
  </div>
}
